module.exports = __webpack_public_path__ + "assets/img/36_566.6a0fe7cf.jpg";